import { render, staticRenderFns } from "./ShowProfitToggle.vue?vue&type=template&id=24170476"
import script from "./ShowProfitToggle.vue?vue&type=script&lang=ts"
export * from "./ShowProfitToggle.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports